import 'css-chunksrc/client/pages/exportsPage/resourceProjectAllocation/sort/styles.scss';export default {
  "sort": "_sort_p1q7w_1",
  "label": "_label_p1q7w_9",
  "input": "_input_p1q7w_15",
  "placeholder": "_placeholder_p1q7w_31",
  "icon": "_icon_p1q7w_39",
  "listRoot": "_listRoot_p1q7w_47",
  "list": "_list_p1q7w_47",
  "item": "_item_p1q7w_63",
  "option": "_option_p1q7w_76",
  "selected": "_selected_p1q7w_83",
  "opened": "_opened_p1q7w_96"
};